import { SET_CURRENT_PAGINATION_NUMBER as r } from "./types.js";
const i = {
  institutionsTable: { currentPaginationNumber: 1 },
  individualInstitutionTable: { currentPaginationNumber: 1 },
  latestUserActivityTable: { currentPaginationNumber: 1 },
  completedJobsTable: { currentPaginationNumber: 1 },
  failedJobsTable: { currentPaginationNumber: 1 },
  aggReportsTable: { currentPaginationNumber: 1 }
};
function b(e = i, t) {
  switch (t.type) {
    case r:
      const { reduxTableName: a, data: n } = t.payload;
      return { ...e, [a]: n };
    default:
      return e;
  }
}
export {
  b as tableReducer
};
//# sourceMappingURL=reducers.js.map
